import gql from 'graphql-tag';

const CROP_NAME_LIST = gql`
  query Query {
    cropNames {
      cropName
    }
  }
`;

export default CROP_NAME_LIST;
